import EventBus from "../EventBus";

export const basket = {

    data() {
        return {
            basket: {
                photofixr: 'example'
            }
        }
    },
    beforeCreate() {
        // // let parameters = window.location.search.split('=')
        // // console.log(parameters[0])
        // if (parameters.length > 1 && parameters[0] === '?transferToken') {
        //     // console.log('not going to the login page')
        // } else if (document.cookie == '') {
        //     // window.location = "/introduction";
        //     // document.getElementById("popup").style.display = "block";
        // }

        // console.log('checking login popup')
        // console.log(typeof this.returnCookie("_token") == 'undefined')
        // if (typeof this.returnCookie("_token") == 'undefined') {
        //     EventBus.$emit('login', 'show login')
        //     console.log('eventBus')
        // }
    },
    computed: {
        rights() {
            return this.basket.photofixr;
        }
    },
    // watch: {
    //     rights() {
    //         return this.basket.photofixr;
    //     }
    // },
    methods: {
    }
}


// const store = new Vuex.Store({
//     state: {
//         count: 0
//     },
//     mutations: {
//         increment: state => state.count++,
//         decrement: state => state.count--
//     }
// })
//
// new Vue({
//     el: '#app',
//     computed: {
//         count () {
//             return store.state.count
//         }
//     },
//     methods: {
//         increment () {
//             store.commit('increment')
//         },
//         decrement () {
//             store.commit('decrement')
//         }
//     }
// })